import styled from "styled-components";

export const Layout = styled.div`
  width: 100%;
`;

export const Header = styled.h3`
  padding: 10px;
  font-size: 20px;
  text-align: center;
  color: #555;
`;
export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 8px;
  padding: 12px;
`;